import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=f1b0f8fc&"
import script from "./Region.vue?vue&type=script&lang=js&"
export * from "./Region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1b0f8fc')) {
      api.createRecord('f1b0f8fc', component.options)
    } else {
      api.reload('f1b0f8fc', component.options)
    }
    module.hot.accept("./Region.vue?vue&type=template&id=f1b0f8fc&", function () {
      api.rerender('f1b0f8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Region.vue"
export default component.exports